import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { UiSdgIconsList } from '../model/ui-icons.model';

@Injectable({
  providedIn: 'root'
})
export class UiSdgIconsService {
  private cachedIcons = new Map<UiSdgIconsList, string>();

  constructor(private http: HttpClient) {}

  getIconContent(iconKey: UiSdgIconsList, language: string) {
    if (this.cachedIcons.has(iconKey)) {
      return of(this.cachedIcons.get(iconKey));
    }

    return this.http.get(`assets/ui-icons/sdg/sdg-${language}/${iconKey}.svg`, { responseType: 'text' }).pipe(
      catchError(() => {
        console.error(`Icon ${iconKey} failed to be loaded`);
        return of('');
      }),
      tap(iconContent => this.cachedIcons.set(iconKey, iconContent))
    );
  }
}
